<template>
  <div
    v-show="zoomOptions.isShow"
    class="osk-zoom"
    :style="`top: ${zoomOptions.zoomPosition.y}px; left: ${zoomOptions.zoomPosition.x}px;`"
  >
    <img
      v-if="zoomOptions.imageSrc"
      class="osk-zoom__img"
      :style="`top: ${zoomOptions.zoomImgPosition.y}px; left: ${zoomOptions.zoomImgPosition.x}px;`"
      width="1080"
      height="1280"
      alt=""
      :src="zoomOptions.imageSrc"
    >
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, reactive } from 'vue';
import { ZoomOptionsType } from '~/types/components/zoom';
import { isImgElement } from '~/utils/html';

const zoomOptions = reactive<ZoomOptionsType>({
  isShow: false,
  imageSrc: '',
  image: null,
  cursor: {
    x: 0,
    y: 0,
  },
  imgOffset: {
    x: 0,
    y: 0,
  },
  zoomPosition: {
    x: 0,
    y: 0,
  },
  zoomImgPosition: {
    x: 0,
    y: 0,
  },
});

function setZoomPosition() {
  let zoomPosX = zoomOptions.cursor.x;
  let zoomPosY = zoomOptions.cursor.y;

  const viewHeight = document.body.offsetHeight;
  const viewWidth = document.body.offsetWidth;

  if (zoomPosX + 150 > viewWidth) {
    zoomPosX = viewWidth - 150;
  }
  if (zoomPosY + 150 > viewHeight) {
    zoomPosY = viewHeight - 150;
  }
  if (zoomPosX - 150 < 0) {
    zoomPosX = 150;
  }
  if (zoomPosY - 150 < 0) {
    zoomPosY = 150;
  }
  zoomOptions.zoomPosition = { x: zoomPosX, y: zoomPosY };
}

function setZoomImagePosition() {
  const { top, left } = zoomOptions.image!.getBoundingClientRect();

  zoomOptions.imgOffset = { y: top, x: left };
  const { offsetWidth, offsetHeight } = zoomOptions.image!;

  zoomOptions.zoomImgPosition = {
    y: (1280 - 300) * ((zoomOptions.imgOffset.y - zoomOptions.cursor.y) / offsetHeight),
    x: (1080 - 300) * ((zoomOptions.imgOffset.x - zoomOptions.cursor.x) / offsetWidth),
  };
}

function checkPointerPosition(e:MouseEvent) {
  if (!isImgElement(e.target) || !e.target.classList.contains('zoomMe') || window.innerWidth < 1023) {
    zoomOptions.isShow = false;
    return;
  }
  const imgHovered = e.target;

  zoomOptions.cursor = { x: e.clientX, y: e.clientY };
  zoomOptions.image = imgHovered;
  setZoomPosition();
  setZoomImagePosition();
  zoomOptions.imageSrc = imgHovered.getAttribute('src');
  zoomOptions.isShow = true;
}

onMounted(() => {
  window.addEventListener('mousemove', checkPointerPosition);
});
onUnmounted(() => {
  window.removeEventListener('mousemove', checkPointerPosition);
});
</script>

<style lang="scss" scoped>
@import "~/assets/scss/settings/index";

.osk-zoom {
  width: 300px;
  height: 300px;
  border: 1px solid #f2f2f2;
  position: fixed;
  z-index: 13;
  overflow: hidden;
  pointer-events: none;
  background: $white;
  transform: translate(-50%, -50%);

  &__img {
    position: absolute;
    width: 1080px;
    height: 1280px;
    max-width: none;
  }
}
</style>
